export default "__VITE_ASSET__CsGrN94Q__"